import { AuthenticationConfig } from '@/core/components/authentication/authentication.module';
import { ExtendedAuthenticationService } from '@/core/components/authentication/services/extended-authentication.service';
import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AUTHENTICATION_CONFIG } from '@/core/components/authentication/injection-tokens';

@Injectable({
  providedIn: 'root'
})
export class NotAuthenticatedGuard implements CanActivate {
  constructor(protected authenticationService: ExtendedAuthenticationService, @Inject(AUTHENTICATION_CONFIG) protected authenticationConfig: AuthenticationConfig, protected router: Router){}

  canActivate() {
    if (this.authenticationService.isAuthenticated())
      this.router.navigateByUrl(this.authenticationConfig.defaultRedirectUrl);

    return true;
  }
}